module.exports = __webpack_public_path__ + "img/2建立晶格20220420_100652.96af76b0.gif";